@import '../../../../design-tokens/dist/private/colors';
@import '../../../../style/src/typography/mixins';

$zds-text-colors: 'base', 'contrast', 'danger', 'loud';

// Sets all possible --zds-badge-background values based on the colors that exist within the design tokens.
@each $color in $zdsColors {
	:host([color='#{$color}']) {
		--zds-badge-background: var(--zds-color-#{$color});
		--zds-badge-color: var(--zds-color-#{$color}-foreground);
	}
}

// Sets all possible --zds-badge-background values based on the text colors that exist within the design tokens.
@each $color in $zds-text-colors {
	:host([color='#{$color}']) {
		--zds-badge-background: var(--zds-text-color-#{$color});
		--zds-badge-color: var(--zds-text-color-contrast);

		@if $color == 'contrast' {
			--zds-badge-color: var(--zds-text-color-base);
		}
	}
}

:host {
	@include zds-typography('body');

	display: inline-flex;
	font-size: inherit;
	font-weight: inherit;
	line-height: inherit;
}

:host(.zds-badge-square) {
	--zds-badge-border-radius: 0;
}

:host([outlined='']),
:host([outlined='true']) {
	--zds-badge-color: var(--zds-text-color-base);
}

:host([pill='']),
:host([pill='true']) {
	--zds-badge-border-radius: var(--zds-shape-radius-pill);
}

.zds-badge {
	position: relative;
}

.zds-badge__badge {
	background: var(--zds-badge-background);
	border-radius: var(--zds-badge-border-top-left-radius, var(--zds-badge-border-radius))
		var(--zds-badge-border-top-right-radius, var(--zds-badge-border-radius))
		var(--zds-badge-border-bottom-right-radius, var(--zds-badge-border-radius))
		var(--zds-badge-border-bottom-left-radius, var(--zds-badge-border-radius));
	color: var(--zds-badge-color);
	font-size: var(--zds-badge-font-size);
	font-weight: var(--zds-badge-font-weight);
	line-height: 1;
	padding: var(--zds-badge-inset-y) var(--zds-badge-inset-x);
	z-index: 1;

	&--empty {
		height: var(--zds-badge-empty-size);
		padding: 0;
		width: var(--zds-badge-empty-size);
	}

	&--outlined {
		background: var(--zds-color-white);
		border: 1px solid var(--zds-badge-background);
		color: var(--zds-badge-color);
	}

	// When overlaying content
	&--overlaying {
		bottom: calc(100% - 10px);
		box-shadow: 0 1px 1px 0 color-mix(in srgb, var(--zds-color-grey-900) 25%, transparent);
		left: calc(100% - 10px);
		position: absolute;
	}

	// Special case when overlaying a zds-icon
	&--overlaying-icon {
		bottom: calc(100% - 16px);
		left: calc(100% - 13px);
	}

	// When overlaying content, if an empty badge
	&--empty.zds-badge__badge--overlaying {
		bottom: calc(100% - var(--zds-badge-empty-size) / 2);
		left: calc(100% - var(--zds-badge-empty-size) / 2);
	}

	// Special case when overlaying a zds-icon, if an empty badge
	&--empty.zds-badge__badge--overlaying-icon {
		bottom: calc(100% - var(--zds-badge-empty-size) * 0.5 - 6px);
		left: calc(100% - var(--zds-badge-empty-size) * 0.5 - 3px);
	}
}
